export default {
    fields: [
        {
            type: "text",
            label: "Cart ID*",
            queryParam: "cartSpecialId",
            rules: [
                v => (!!v && v.length >= 1) || "Should be atleast 1 characters"
            ],
            updatable: true
        },
        {
            type: "text",
            label: "Name*",
            queryParam: "name",
            rules: [
                v => (!!v && v.length >= 1) || "Should be atleast 1 characters"
            ],
            updatable: true
        },
        {
            type: "text",
            label: "Display Name*",
            queryParam: "displayName",
            rules: [
                v => (!!v && v.length >= 1) || "Should be atleast 1 characters"
            ],
            updatable: true
        },
        {
            type: "dropdown",
            model: "stations",
            label: "Station*",
            queryParam: "stationId",
            rules: [v => v !== undefined || "This field is mandatory"],
            updatable: true
        },
        {
            type: "dropdown",
            model: "states",
            label: "Status*",
            queryParam: "stateId",
            rules: [v => v !== undefined || "This field is mandatory"],
            updatable: true
        },
        {
            type: "dropdown",
            model: "contracts",
            label: "Contract*",
            queryParam: "contractId",
            rules: [v => v !== undefined || "This field is mandatory"],
            updatable: true
        },
        {
            type: "dropdown",
            model: "locations",
            label: "Location*",
            queryParam: "locationId",
            rules: [v => v !== undefined || "This field is mandatory"],
            updatable: true
        },
        {
            type: "text",
            label: "Pitch*",
            queryParam: "pitch",
            rules: [
                v => Number.isInteger(Number(v)) || "Should be a number"
            ],
            valueFormatter: v => Number(v),
            updatable: true
        },
        {
            type: "text",
            label: "Car#",
            queryParam: "car",
            rules: [],
            updatable: true
        },
        {
            type: "text",
            label: "Device#*",
            queryParam: "deviceNumber",
            rules: [v => v !== undefined || "This field is mandatory"],
            updatable: true
        },
        {
            type: "text",
            label: "Short String*",
            queryParam: "shortString",
            rules: [v => v !== undefined || "This field is mandatory"],
            updatable: true
        },
        {
            type: "text",
            label: "Version",
            queryParam: "version",
            rules: [],
            valueFormatter: v => Number(v),
            updatable: true
        },
        {
            type: "dropdown",
            model: "modules",
            label: "Module*",
            queryParam: "moduleId",
            rules: [v => v !== undefined || "This field is mandatory"],
            updatable: true
        },
        {
            type: "dropdown",
            model: "logistics-handling-groups",
            label: "LHG*",
            queryParam: "logisticsHandlingGroupId",
            // rules: [v => v !== undefined || "This field is mandatory"],  
            updatable: true,
            nullable: true,
        },
        {
            type: "datepicker",
            label: "Service Due",
            queryParam: "serviceDue",
            value: "2025-12-31",
            valueFormatter: v => { return v + "T00:00:00Z" },
            updatable: true
        }
    ]
}